import {useQuery} from '@tanstack/react-query'

import {type YouTubeOEmbedResponse} from '#/lib/videos'
import {STALE} from '#/state/queries'

const RQKEY_ROOT = 'youtube-oembed'
export const RQKEY = (videoId: string) => [RQKEY_ROOT, videoId]

/**
 * Fetch YouTube video metadata using the oEmbed API
 * No API key required
 */
export function useYouTubeOEmbedQuery({
  videoId,
  enabled = true,
}: {
  videoId: string | undefined
  enabled?: boolean
}) {
  return useQuery<YouTubeOEmbedResponse>({
    queryKey: RQKEY(videoId ?? ''),
    queryFn: async () => {
      const url = `https://www.youtube.com/oembed?format=json&url=https://www.youtube.com/watch?v=${videoId}`
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error('Failed to fetch video metadata')
      }
      return response.json()
    },
    staleTime: STALE.HOURS.ONE,
    enabled: !!videoId && enabled,
  })
}
